// The pointer-hand cursor, for "click" in keyboard-style hints. Drawn in
// `currentColor` like PencilIcon so the hint's text colour drives it.
export function CursorIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      className={className}
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9 11V4.5a1.5 1.5 0 0 1 3 0V11" />
      <path d="M12 10.5a1.5 1.5 0 0 1 3 0V12" />
      <path d="M15 11.5a1.5 1.5 0 0 1 3 0V13" />
      <path d="M18 12.5a1.5 1.5 0 0 1 3 0V17a5 5 0 0 1-5 5h-3.5a5 5 0 0 1-4.1-2.1L4 14.5a1.5 1.5 0 0 1 2.4-1.8L9 15.5" />
    </svg>
  );
}
